<template>
  <div class="commonDialogBody">
     <BillShareDepartmentDialogtwo @AllData="getMsgFormSon"  ref="BillShareDepartmentDialogtwo" /> <!--  // 共享部门配置 -->
      <BillShareDepartmentDialogone @officeArr="officeArr"  ref="BillShareDepartmentDialogone" /> <!--  // 共享部门配置 -->
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.mangroupName" >
    <el-select  clearable v-model="value" placeholder="请选择" @change="ChargeBillManTree">
    <el-option v-for="item in options" :key="item.officeId" :label="item.officeName" :value="item.officeId">
    </el-option>
  </el-select>
  <el-button @click="receive()">配置</el-button>
</el-form-item>
  <el-form-item :label="formLabelAlign.obj.BillListName" >
    <el-select  clearable v-model="billvalue" placeholder="请选择" multiple @change="ChargeBillList">
    <el-option v-for="item in BillList" :key="item.officeId" :label="item.officeName" :value="item.officeId">
    </el-option>
  </el-select>
   <el-button @click="share()">配置</el-button>
</el-form-item>
   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BillShareDepartmentDialogtwo from "../common/BillShareDepartmentDialogtwo.vue";
import BillShareDepartmentDialogone from "../common/BillShareDepartmentDialogone.vue";
export default {
  components: {BillShareDepartmentDialogone,BillShareDepartmentDialogtwo},
  name: "BillShareDepartmentDialog",
  data() {
    return {
    options:[],
    value:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    BillList:[],
    billvalue:"",
    typeName:"",
    Pid:"",
    mangroupName:"",
    officeName:"",
    shareOfficeNames:[],
    TreeData:{}
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.title == "添加"){
          this.value = ""
          this.billvalue = ""
        }
      }
    }
  },
  methods: {
    officeArr(data){
      let arr = []
      arr.push(data)
      this.options = arr
      this.value = arr[0].officeId
      this.officeName = arr[0].officeName
    },
    receive(){
      this.$refs.BillShareDepartmentDialogone.title = "配置";
      this.$refs.BillShareDepartmentDialogone.dialogVisi = true;
    },
    share(){
      // 共享部门配置
      this.$refs.BillShareDepartmentDialogtwo.title = "配置";
      this.$refs.BillShareDepartmentDialogtwo.dialogVisi = true;
    },
    ChargeBillManTree(){
        // console.log(this.value)
        for(let val of this.options){
          if(val.value == this.value){
            this.Pid = val.value
            this.mangroupName = val.label
          }
        }
    },
    ChargeBillList(){
        for(let val of this.BillList){
          if(val.billvalue ==  this.billvalue){
              this.typeName = val.billlabel
          }
        }
    },
    modification(){
        if(this.title == "修改"){
               let obj = {
                 "id":this.formLabelAlign.id,
              "shareOfficeIds":this.billvalue,
              "takeOffice":this.value,
              "takeOfficeName":this.officeName,
              "shareOfficeNames":this.shareOfficeNames,
              "remarks":this.formLabelAlign.remarks,
              }
            if(obj.takeOfficeName == undefined || obj.takeOfficeName == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.shareOfficeNames == undefined || obj.shareOfficeNames == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILLSHARE_ADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "添加"){
               let obj = {
              "shareOfficeIds":this.billvalue,
              "takeOffice":this.value,
              "takeOfficeName":this.officeName,
              "shareOfficeNames":this.shareOfficeNames,
              "remarks":this.formLabelAlign.remarks,
                }
          if(obj.takeOfficeName == undefined || obj.takeOfficeName == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.shareOfficeNames == undefined || obj.shareOfficeNames == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILLSHARE_ADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
              this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }


    },
    getMsgFormSon(data){
      let array = []
        this.BillList = data
        let arr = []
        for(let val of data){
          arr.push(val.officeId)
          array.push(val.officeName)
        }
        this.shareOfficeNames = array
        this.billvalue = arr
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
       if(this.formLabelAlign.obj == undefined){
           let obj = {
            "mangroupName":"领用部门名称",
            "BillListName":"共享部门名称",
            "remarks":"备注信息",
          }
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>